export function toLowerCaseFirstCharacterSmartIsh(s: string): string {
  if (s === s.toUpperCase()) return s;
  const firstCharacterLower = s.charAt(0).toLowerCase();
  if (s.charAt(0) === firstCharacterLower) return s;
  const words = s.split(' ');
  if (words[0] === words[0].toUpperCase()) return s;
  return `${firstCharacterLower}${s.substring(1)}`;
}
